export const CUSTOMER_QUERY_KEY = 'customers';
export const MEMBER_QUERY_KEY = 'members';
export const MERGED_CUSTOMER_QUERY_KEY = 'merged-customer';
export const LOYALTY_QUERY_KEY = 'loyalty';
export const ORDER_HISTORY_QUERY_KEY = 'orders-history';
export const ORDER_DETAIL_QUERY_KEY = 'order-detail';
export const CREDIT_HISTORY_QUERY_KEY = 'credit-history';
export const ACCOUNT_HISTORY_QUERY_KEY = 'account-history';
export const POINTS_HISTORY_QUERY_KEY = 'points-history';
export const PACKAGE_QUERY_KEY = 'packages';
export const STORES_QUERY_KEY = 'stores';
export const CONFIGS_QUERY_KEY = 'configs';
export const RUNTIME_CONFIG_QUERY_KEY = 'runtime-config';
export const MY_REWARD_QUERY_KEY = 'my_rewards';
export const BROADCAST_VOUCHER_QUERY_KEY = 'broadcast_vouchers';
export const TIER_RANK_QUERY_KEY = 'tier-rank';

